<script lang="ts">
  import CategoryBanner from '$lib/components/category/CategoryBanner.svelte'
	import CategoryPromoBanner from '$lib/components/category/CategoryPromoBanner.svelte'
  import ProductsSlider from '$lib/components/ProductsSlider.svelte'
  import { page } from '$app/stores';
	import { is_set_object } from '$lib/js/helpers';
  import { t } from 'svelte-i18n-lingui';

  export let category;
</script>


{#if is_set_object(category)}
  <div class="category-hero">
    <CategoryBanner category={category}/>

    {#if $page.data.promo_prods && $page.data.promo_prods.length >= 1 && !$page.url.searchParams.get("promo")}
      <div class="container promo-prods">
        <ProductsSlider products={$page.data.promo_prods} title="{$t`Promotions!`}" type="promo"/>
      </div>
    {/if}
  </div>

  <CategoryPromoBanner />
{/if}


<style lang="scss">
  .promo-prods {
    margin: 50px auto 80px;
  }
</style>
